module.exports = __webpack_public_path__ + "img/hd-mail-icon.3d5c67fd.svg";